<template>
  <div class="content-slider-3">
    <m-content-wrapper :content-type="contentType" :category-column="categoryColumnProp"
                       :content-category="contentCategory">
      <template v-slot="{contents}">
        <swiper
            :grabCursor="grabCursor"
            :effect="effect"
            :loop="loop"
            v-bind="swiperOptions"
            :autoplay="autoplay" :modules="modules" class="mySwiper">

          <swiper-slide class="py-4" v-for="content in contents" :key="content.id">
            <m-a v-if="cardLink" class="text-decoration-none" :href="findLinkOnContent(content.abstraction)">
              <component :is="contentCard" :content="content"/>
            </m-a>
            <component v-else :is="contentCard" :content="content"/>
          </swiper-slide>

        </swiper>
      </template>
    </m-content-wrapper>
  </div>
</template>

<script>
import {Swiper, SwiperSlide} from "swiper/vue";
import {ContentArchiveProps} from '../Archive/ContentArchiveProps'
import mContentWrapper from "../../Wrappers/ContentWrapper";
import mContentCard907 from "../Card/ContentCard907";
import mA from '../../Tags/A'
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';
import {Navigation, Autoplay} from "swiper";
import {Cards} from "../../Content/Card/Cards";

export default {
  name: "ContentSlider3",
  components: {mContentCard907, mContentWrapper, mA, Swiper, SwiperSlide, ...Cards},
  props: {
    ...ContentArchiveProps,
  },
  methods: {
    contentLink(content) {
      const routerName = content.content_type === 0 ? 'SinglePage' : 'SinglePost';
      return {name: routerName, params: {slug: content.slug}}
    }
  },
  setup() {
    return {
      modules: [Navigation, Autoplay],
    };
  },
  data() {
    return {
      effect: 'cube',
      grabCursor: true,
      loop: true,
      centeredSlides: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false
      },
      swiperOptions: {
        slidesPerView: "auto",
        grabCursor: true,
        freeMode: true,
        centeredSlides: true,
        autoplay: {
          delay: 0,
          disableOnInteraction: false
        },
        spaceBetween: 30,
        speed: 7500,
        loop: true,
        breakpoints: {
          300: {
            slidesPerView: 1,
          },
          400: {
            slidesPerView: 1,
          },
          430: {
            slidesPerView: 1,
          },
          490: {
            slidesPerView: 1,
            spaceBetween: 50,
          },
          520: {
            slidesPerView: 2,
            spaceBetween: 50,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 50,
          },
          980: {
            slidesPerView: 4,
          },
          1200: {
            slidesPerView: 4,

          },
        },
      },
    }
  }
}
</script>

<style scoped>
.content-slider-3 >>> .swiper-wrapper {
  transition-timing-function: linear;
}
</style>